module.exports = __webpack_public_path__ + "img/user.8ec11d70.png";